export default __webpack_public_path__ + "static/graphik-web-light-483cf08c7dbed2e3b83cd24908bc9a2b.woff2";